import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: async () => await import('@/pages/home/index.vue'),
    meta: { title: '乐道' }
  }
]

const router = createRouter({
  history: createWebHistory(`/`),
  routes
})

export default router
